import { Component, AfterContentInit, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IProductsModel } from '../../../shared/models/products.model';
import { AgreementsModel } from '../../../shared/models/agreements.model';
import { ObjectCheckModel } from '../../../shared/models/live-abroad.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ConfigurationService } from '../../../shared/services/configuration/configuration.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { FirmlyApprovedService } from '../../../shared/services/firmly-approved/firmly-approved.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_LD,
  PAGEVIEW as PAGEVIEW_FA_LD,
  CHANNEL as CHANNEL_FA_LD,
  COUNTRY as COUNTRY_FA_LD,
  BUSINNESS as BUSINNESS_FA_LD,
  ENVIRONMENT as ENVIRONMENT_FA_LD,
  FAMILY as FAMILY_FA_LD,
  SUBFAMILY as SUBFAMILY_FA_LD,
  PRODUCT as PRODUCT_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { IRescueData } from 'src/app/shared/interfaces/rescue-data.interface';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { RescueDataModel } from 'src/app/shared/models/rescue-data.model';

@Component({
  selector: 'app-confirm-phone',
  templateUrl: './confirm-phone.component.html',
  styleUrls: ['./confirm-phone.component.scss'],
})
export class ConfirmPhoneComponent implements AfterContentInit, OnInit {

  formGroup: FormGroup;
  productsDetail: IProductsModel;
  agreementSelected: AgreementsModel;
  selectedProduct: IProductsModel;
  selectedShippingMethod: ObjectCheckModel;
  updatingPhone: boolean;
  showedPhone: string;
  reactiveErrorPhone = '';
  disableButton = false;
  inputType = 'number';

  /**
   * Objeto de información de contacto
   *
   * *Information contact object*
   *
   * @access public
   * @type {ContactModel}
   */

  contactInfo: ContactModel;

  product_select: any;
  private rescueData: IRescueData;
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private configurationService: ConfigurationService,
    private validationHelperService: ValidationHelperService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private taggingServices: TaggingService,
  ) {
    this.headerService.show(true, true, true);
    this.setContactInfo();
    this.rescueData = new RescueDataModel();
  }
  ngOnInit(): void {
    this.sendTagging('init');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendPhoneConfirmPageLoad();
    }
  }

  /**
   * Summary Call after angular has fully started the component view, initialization of the form
   */
  ngAfterContentInit() {
    this.product_select = this.abreCuentasService.getproductSelected();
    if (this.product_select.product_type != BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.getRescueData();
    }
    const validators = [Validators.required, Validators.maxLength(10), Validators.pattern(/^3\d{9}$/)];
    const contactInfo = this.abreCuentasService.getContactInfo().mobile_number;
    this.updatingPhone = this.abreCuentasService.getProspectResponse() && this.abreCuentasService.getProspectResponse().client && !this.abreCuentasService.getUpdatingPhone() && !this.abreCuentasService.haveLoan;
    this.showedPhone = contactInfo;
    if (this.updatingPhone) {
      this.showedPhone = this.validationHelperService.maskPhone(contactInfo);
      this.inputType = 'text';
      this.formGroup = new FormGroup({
        'input-value-phone': new FormControl({ value: this.showedPhone, disabled: true }),
      });
    } else {
      this.formGroup = new FormGroup({
        'input-value-phone': new FormControl(this.showedPhone, validators),
      });
    }
  }

  getRescueData() {
    if (!this.abreCuentasService.rescueDataIsEmpty()) {
      this.rescueData = this.abreCuentasService.getRescueData();
      this.contactInfo.mobile_number = this.rescueData.mobile_number;
    }
  }

  /**
   * Summary  event phone entry change, error validation
   */
  reactiveInputChangePhone() {
    this.contactInfo = this.abreCuentasService.getContactInfo();
    this.contactInfo.mobile_number = this.formGroup.controls['input-value-phone'].value;
    this.abreCuentasService.setContactInfo(this.contactInfo);
    const controlPhone = this.formGroup.controls['input-value-phone'] as FormControl;
    controlPhone.setValue(controlPhone.value.slice(0, 10));
    controlPhone.setValue(controlPhone.value.replace(new RegExp(/[^\d]/), ''));
    if (controlPhone.valid) {
      this.disableButton = false;
      this.reactiveErrorPhone = '';
    } else {
      this.disableButton = true;
      this.reactiveErrorPhone = this.copyService.copies.confirm_phone_error;
    }
  }

  next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    const body = {
      data: {
        agency: this.abreCuentasService.getAgencySelected(),
        phone: this.formGroup.controls['input-value-phone'].value,
      },
    };
    const contactInfo = this.abreCuentasService.getContactInfo();
    contactInfo.mobile_number = body.data.phone;
    this.contactInfo.mobile_number = this.formGroup.controls['input-value-phone'].value;
    this.abreCuentasService.setContactInfo(contactInfo);
    this.setRescueData(this.contactInfo);
    this.configurationService.offersConfig(body).then(async (response: any) => {
      console.log('respuesta de confirm-phone.component: ', response);
      if (!response) { return; }
      if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
        this.navigationService.nextStep(response.status);
      } else {
        if (response.status === 500) {
          this.navigationService.navigateToGeneralInformation('500');
          return;
        }
        this.productsDetail = this.abreCuentasService.getproductSelected();
        console.log('///** PRODUCT ' + this.productsDetail.code);
        if (this.productsDetail.code === '201' || this.productsDetail.code === '203') {
          this.searchBenefits();
          return;
        }
        if (this.navigationService.getCurrentProductProcess().name === 'creditCard') {
          this.configurationService.sendCardInformation();
          return;
        }

        if (this.abreCuentasService.viewOptionMultiProduct) {
          this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
        } else if (this.abreCuentasService.getUserJemelii()) {
          this.navigationService.nextStep('201');
        } else {
          this.navigationService.nextStep('200');
        }
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  private searchBenefits() {
    this.agreementSelected = this.abreCuentasService.getAgreementSelected();
    this.productsDetail = this.abreCuentasService.getproductSelected();
    console.log('///** TRANSACTION TYPE ' + this.agreementSelected.transaction_type);
    if (this.agreementSelected.transaction_type === 'false') {
      const agreementCode = this.agreementSelected.agreement_code;
      this.configurationService.offersGetBenefits(agreementCode).then((response: any) => {
        if (response) {
          this.configurationService.benefitsFilter(response.data[0].benefits);
          if (this.abreCuentasService.getUserJemelii() && (this.productsDetail.code === '201' || this.productsDetail.code === '203')) {
            this.navigationService.nextStep('201');
          }
          this.navigationService.nextStep();
        }
      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
      return;
    } else if (this.abreCuentasService.getUserJemelii() && (this.productsDetail.code === '201' || this.productsDetail.code === '203')) {
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep();
    }
  }

  setRescueData(data: any) {
    this.rescueData.mobile_number = data.mobile_number;
    this.abreCuentasService.setRescueData(this.rescueData);
  }

  setContactInfo() {
    const contactInfo = this.abreCuentasService.getContactInfo();
    if (!contactInfo.mobile_number) {
      this.contactInfo = new ContactModel();
      this.contactInfo.mobile_number = '';
      this.abreCuentasService.setContactInfo(this.contactInfo);
      return;
    }
    this.contactInfo = contactInfo;
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendPhoneConfirmPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA_LD.pv12pageName.path,
        value: `${isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking}:${COUNTRY_FA_LD.co}:${BUSINNESS_FA_LD.pf}:${ENVIRONMENT_FA_LD.loggeado}:${FAMILY_FA_LD.services}:${SUBFAMILY_FA_LD.request}:${PRODUCT_FA_LD.request}:${PAGEVIEW_FA_LD.pv12pageName.value}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv12pageFamily.path,
        value: PAGEVIEW_FA_LD.pv12pageFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv12subFamily.path,
        value: PAGEVIEW_FA_LD.pv12subFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv12pageAction.path,
        value: PAGEVIEW_FA_LD.pv12pageAction.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv12pageid.path,
        value: ConfirmPhoneComponent.name,
      },
      {
        path: PAGEVIEW_FA_LD.pv12transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv12transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv12transactionTransactionStep.path,
        value: PAGEVIEW_FA_LD.pv12transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv12E1setData.pv12E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv12E1setData.pv12E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv12E1setData.pv12E1transactionName.path,
        value: `${EVENT_FA_LD.pv12E1setData.pv12E1transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv12E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv12E2setData.pv12E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv12E2setData.pv12E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv12E2setData.pv12E2transactionName.path,
        value: `${EVENT_FA_LD.pv12E2setData.pv12E2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv12E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '18';
    const extras = {
      pageValue: 'ConfirmPhone',
    };
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }
}
